import { GridHeaderComponent } from '../rankings/data-widgets/grid-header.component';
import { RiskPillOnlyComponent } from '../rankings/data-widgets/risk-pill-only.component';
import { DeveloperNameComponent } from '../rankings/data-widgets/developer-name.component';
import { RatingBarV2Component } from '../rankings/data-widgets/rating-bar-v2.component';
import { GridHeaderWithTooltipComponent } from '../rankings/data-widgets/grid-header-with-tooltip.component';
import { TOOLTIPS } from 'app/constants/TOOLTIPS';
import { ReportConfig } from '../rankings/REPORT_CONFIG';

export const OVERALL_RISK_OPTIONS = [
  {
    label: 'All Child Safety Risk Levels',
    value: ''
  },
  {
    label: 'Failure',
    value: 'F'
  },
  {
    label: 'High',
    value: 'H'
  },
  {
    label: 'Medium',
    value: 'M'
  },
  {
    label: 'Low',
    value: 'L'
  }
];

export const DEVICE_OPTIONS = [
  {
    label:
      '<img class="mr-2" src="/assets/images/google-play.svg" alt="Google Play Icon"/> Google Play',
    value: 'android'
  },
  {
    label:
      '<img class="mr-2" src="/assets/images/apple.svg" alt="App Store Icon"/> App Store',
    value: 'ios'
  }
];

export const KYD_REPORT_CONFIG: ReportConfig[] = [
  {
    key: 'developer-trust-index',
    heading: 'Know Your Developer™',
    subHeading:
      'App Developer Online Child Safety Checks for Parents & Teachers',
    title: 'Know Your Developer',
    pageTitle: 'Know Your Developer | Pixalate',
    pageMeta: 'Explore Pixalate’s Know Your Developer',
    reportId: 'developerTrustIndex',
    sortable: false,
    permissions: [],
    notHideDataIfNA: true,
    mainFilterItems: [
      {
        key: 'appStore',
        algoliaKey: 'appStore',
        label: 'App Store',
        hidden: false,
        type: 'toggle-filter',
        selected: DEVICE_OPTIONS[0],
        options: [...DEVICE_OPTIONS]
      },
      {
        key: 'overallRisk',
        algoliaKey: 'kydOverallRisk',
        label: 'Child Safety Risk',
        hidden: false,
        type: 'dropdown-toggle-filter',
        showCount: true,
        selected: OVERALL_RISK_OPTIONS[0],
        options: [...OVERALL_RISK_OPTIONS]
      },
      {
        key: 'developerCountryCode',
        // algoliaKey: 'developerCountryCode',  // TODO: enable once algolia index is updated
        label: 'Country',
        hidden: false,
        selected: { label: 'All Countries', value: '' },
        options: [{ label: 'All Countries', value: '' }],
        dependencies: [{ key: 'date' }, { key: 'overallRisk' }]
      },
      {
        key: 'date',
        label: 'Month',
        selected: null,
        hidden: false,
        options: []
      }
    ],
    gridHeaders: [
      {
        label: 'App Developer',
        key: 'developerName',
        sort: '',
        sortDefault: false,
        sortColumnKey: 'developerName',
        hoverKey: '',
        template: null,
        widgetComponent: DeveloperNameComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderComponent
      },
      {
        label: 'Child Safety Risk',
        key: 'overallRisk',
        sort: '',
        sortDefault: false,
        sortColumnKey: 'overallRisk',
        hoverKey: '',
        template: null,
        widgetComponent: RatingBarV2Component,
        hidden: false,
        headerWidgetComponent: GridHeaderComponent
      },
      {
        label: 'Verifiable Parental Consent Not Detected',
        key: 'vpcCoppaRisk',
        sort: '',
        sortDefault: false,
        sortColumnKey: 'vpcCoppaRisk',
        hoverKey: '',
        template: null,
        widgetComponent: RiskPillOnlyComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent,
        tooltipText: {
          app: TOOLTIPS.vpcCoppaRisk
        }
      },
      {
        label: 'Missing Contact Info Risk',
        key: 'missingContactRisk',
        sort: '',
        sortDefault: false,
        sortColumnKey: 'missingContactRisk',
        hoverKey: '',
        template: null,
        widgetComponent: RiskPillOnlyComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent,
        tooltipText: {
          app: TOOLTIPS.missingContactRisk
        }
      },
      {
        label: 'Missing Privacy Policy Risk',
        key: 'privacyPolicyRisk',
        sort: '',
        sortDefault: false,
        sortColumnKey: 'privacyPolicyRisk',
        hoverKey: '',
        template: null,
        widgetComponent: RiskPillOnlyComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent,
        tooltipText: {
          app: TOOLTIPS.privacyPolicyRisk
        }
      },
      {
        label: 'Location Tracking Risk',
        key: 'locationPermissionRisk',
        sort: '',
        sortDefault: false,
        sortColumnKey: 'locationPermissionRisk',
        hoverKey: '',
        template: null,
        widgetComponent: RiskPillOnlyComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent,
        tooltipText: {
          app: TOOLTIPS.locationPermissionRisk
        }
      },
      {
        label: 'Banned Apps Risk',
        key: 'delistedAppRisk',
        sort: '',
        sortDefault: false,
        sortColumnKey: 'delistedAppRisk',
        hoverKey: '',
        template: null,
        widgetComponent: RiskPillOnlyComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent,
        tooltipText: {
          app: TOOLTIPS.delistedAppRiskKyd
        }
      },
      {
        label: 'Security Risk',
        key: 'abandonedAppRisk',
        sort: '',
        sortDefault: false,
        sortColumnKey: 'abandonedAppRisk',
        hoverKey: '',
        template: null,
        widgetComponent: RiskPillOnlyComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent,
        tooltipText: {
          app: TOOLTIPS.abandonedAppRisk
        }
      },
      {
        label: 'Unsafe Advertising Risk',
        key: 'aggIvtRisk',
        sort: '',
        sortDefault: false,
        sortColumnKey: 'aggIvtRisk',
        hoverKey: '',
        template: null,
        widgetComponent: RiskPillOnlyComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent,
        tooltipText: {
          app: TOOLTIPS.aggIvtRisk
        }
      }
    ]
  }
];
